import { InMemoryCache } from '@apollo/client';
import introspectionQueryResultData from './fragmentTypes.json';

export const fragmentMatcher = new InMemoryCache({
    introspectionQueryResultData
});